import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LayoutPresta from "./layoutPresta";

import { create, update } from "../../services/services";
import TextInput from "../../components/inputs/TextInuput";

import { getMyEtablissement } from "../../store/slices/etablissementSlice";
import { useDispatch, useSelector } from "react-redux";
import EquipeEtablissement from "../../components/etablissement/equipesEtablissement";
import { toast } from "react-toastify";
import { Helmet, HelmetProvider } from "react-helmet-async";


const Equipe = () => {
  const navigate = useNavigate();
  const [members, setMembers] = useState([{ id: 1, name: "" }]);
  const [error, setError] = useState("");

  // Handle input changes for specific member
  const handleMemberChange = (id, value) => {
    setMembers(members.map(member => 
      member.id === id ? { ...member, name: value } : member
    ));
  };

  // Add a new empty member field
  const handleAddMember = () => {
    setMembers([...members, { id: Date.now(), name: "" }]);
  };

  // Remove a member field
  const handleRemoveMember = (id) => {
    if (members.length > 1) {
      setMembers(members.filter(member => member.id !== id));
    } else {
      setError("Vous devez avoir au moins un membre");
      setTimeout(() => setError(""), 3000);
    }
  };
  const dispatch=useDispatch()
    const { selectedEtablissement } = useSelector((state) => state.etablissements);

    useEffect(() => {
      dispatch(getMyEtablissement());
    }, [dispatch]);
  // Submit all members
 
const handleSubmit = async() => {
   
    const validMembers = members.filter(member => member.name.trim() !== "");
    // Separate new members (to be created) and existing members (to be updated)
  const newMembersToCreate = validMembers.filter(member => member.isNew);
  const existingMembersToUpdate = validMembers.filter(
    member => !member.isNew && member.hasChanged // Assuming you track changes
  );
// console.log({existingMembersToUpdate})
    const newMembersToSave = members.filter(
      member => member.isNew && member.name.trim() !== ""
    );
    if (existingMembersToUpdate.length > 0) {
      await Promise.all(
        existingMembersToUpdate.map(member => 
          update(`equipes/${member.id}`, { name: member.name,"status": "0" } )
          .then(() => {
            navigate('/confirm');
           
          })
          .catch((err) => {
            // console.error(err);
            setError("Une erreur est survenue lors de l'enregistrement");
          })
        )
          
      );
    }
    if (newMembersToSave.length === 0) {
      navigate('/confirm');
      return;
    }

    const teamData = newMembersToSave.map(member => ({
      name: member.name,
      etablissement_id: selectedEtablissement?.id,
      status: "active"
    }));

    create(teamData, 'equipes')
      .then(() => {
        navigate('/confirm');
        

      })
      .catch((err) => {
        // console.error(err);
        setError("Une erreur est survenue lors de l'enregistrement");
      });
      // 2. Update existing members (if any)
    
  };
  return (
    <LayoutPresta  btn={false} currentStep={6} nextStep={"/confirm"} handleSubmit={handleSubmit}>
       <HelmetProvider>
                        <Helmet>
                          <title>Inscription Prestataire </title>
                          <meta
                            name="description"
                            content="Inscription Prestataire étape équipe"
                          />
                        </Helmet>
                      </HelmetProvider>
      <div className="container">
        <div className="d-flex justify-content-center mt-48">
          <div className="col-md-6">
            
            <EquipeEtablissement  members={members} setMembers={setMembers}/>
          </div>
        </div>
      </div>

      <div className="ht-100"></div>
    </LayoutPresta>
  );
};

export default Equipe;